export const apiBaseUrl =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_API_BASE_URL
    : "$VUE_APP_API_BASE_URL";

export const useSentry =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SENTRY
    : "$VUE_APP_SENTRY";
